import { render } from "./NotificationOptionsList.vue?vue&type=template&id=499085a3&scoped=true&ts=true"
import script from "./NotificationOptionsList.vue?vue&type=script&lang=ts"
export * from "./NotificationOptionsList.vue?vue&type=script&lang=ts"

import "./NotificationOptionsList.vue?vue&type=style&index=0&id=499085a3&scoped=true&lang=css"

import exportComponent from "C:\\Ventla new admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-499085a3"]])

export default __exports__